export const SDK_VERSION = '8.2.1';
